import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import type {
    GabDictionary,
    GabHeader,
    GabBooking,
    PremiseItem,
    DestinationItem,
} from "./models/GabModule";

export default class GabVuexModule extends AbacoVuexModule {
    /**
     *
     */
    @State({ default: new Date() }) selectedDate!: Date;

    /**
     *
     */
    @State({ default: null }) gabDictionary!: GabDictionary | null;

    /**
     *
     */
    @State({ default: {} }) headers!: Record<string, GabHeader>;

    /**
     *
     */
    @State({ default: {} }) bookings!: Record<string, GabBooking>;

    /**
     *
     */
    @State({ default: {} }) premises!: Record<string, PremiseItem>;

    /**
     *
     */
    @State({ default: {} }) destinations!: Record<string, DestinationItem>;
}
